'use client';

import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import {
  DiscountBadge,
  ProductCardWishListButton,
  ProductImage,
  ProductInformation,
  ReviewInformation,
} from './components';
import type { ProductCardProps } from './ProductCard';
import { Condition } from '@/utils/react';

const HorizontalProductCard = ({
  onClick,
  showRating = true,
  showRanking = true,
  ranking,
  name,
  brand,
  productImage,
  sku,
  currency,
  rating,
  reviewCount,
  originalPrice,
  salePrice,
}: ProductCardProps) => {
  return (
    <Flex width="100%" height="147px" position="relative">
      <Flex
        borderRadius="8px"
        overflow="hidden"
        backgroundColor="common.100"
        direction="row"
        height="100%"
        width="100%"
        alignItems="center"
        gap={3}
        cursor="pointer"
        onClick={(e) => {
          e.stopPropagation();
          onClick?.(e);
        }}
      >
        <Flex
          position="relative"
          backgroundColor="neutral.5"
          width="130px"
          minWidth="130px"
          alignItems="center"
          height="100%"
          borderRadius="8px 0 0 8px"
        >
          <DiscountBadge originalPrice={originalPrice} salePrice={salePrice} />
          <ProductImage imageUrl={productImage} name={name} />
          <Condition
            expression={showRanking}
            then={
              <Text color="text.subtle.inverse" textStyle="title3" position="absolute" bottom={2} left={3.5}>
                {ranking}
              </Text>
            }
          />
        </Flex>
        <Flex direction="row" w="100%" pr={2.5} height="100%" justifyContent="space-between">
          <Flex direction="column" gap={3} w="100%" height="100%" justifyContent="center">
            <Flex direction="column" gap={2} w="100%">
              <ProductInformation.Brand>{brand}</ProductInformation.Brand>
              <ProductInformation.Name height="40px">{name}</ProductInformation.Name>
              <Condition
                expression={showRating}
                then={<ReviewInformation rating={rating} reviewCount={reviewCount} />}
              />
            </Flex>
            <ProductInformation.Price currency={currency} salePrice={salePrice} originalPrice={originalPrice} />
          </Flex>
          <ProductCardWishListButton position="absolute" right={0} top={0} backgroundColor="neutral.5" sku={sku} />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default HorizontalProductCard;
